import { render, staticRenderFns } from "./QuesAns.vue?vue&type=template&id=032fbecf&scoped=true&"
import script from "./QuesAns.vue?vue&type=script&lang=js&"
export * from "./QuesAns.vue?vue&type=script&lang=js&"
import style0 from "./QuesAns.vue?vue&type=style&index=0&id=032fbecf&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "032fbecf",
  null
  
)

export default component.exports